import {StateId} from '@wallaby-ui/core';
import {useCallback, useEffect, useState} from 'react';

import {GridPagination} from 'src/js/containers/grid';
import {loadStateFromParams} from 'src/js/containers/list';
import {useAppDispatch} from 'src/js/store_hooks';

export interface UseInitializeGridReturnType {
  onGridInitialize: () => void;
}

export interface UseInitializeGridParams {
  listStateId: StateId;
  filterAndSearchStateId: StateId;
  locationState;
  gridId: string;
  defaultPagination?: GridPagination;
  featureName?: string;
}

export const useInitializeGrid = (
  params: UseInitializeGridParams
): UseInitializeGridReturnType => {
  const {
    listStateId,
    filterAndSearchStateId,
    locationState,
    gridId,
    defaultPagination,
    featureName,
  } = params;
  const [initialized, setInitialized] = useState<boolean>(false);
  const [isGridInitialized, setIsGridInitialized] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!initialized && isGridInitialized) {
      dispatch(
        loadStateFromParams(
          listStateId,
          filterAndSearchStateId,
          defaultPagination,
          gridId,
          featureName
        )
      );
      setInitialized(true);
    }
  }, [
    defaultPagination,
    initialized,
    isGridInitialized,
    listStateId,
    filterAndSearchStateId,
    gridId,
    dispatch,
    featureName,
  ]);

  useEffect(() => {
    if (locationState.reload) {
      dispatch(
        loadStateFromParams(
          listStateId,
          filterAndSearchStateId,
          undefined,
          gridId,
          featureName
        )
      );
    }
  }, [
    locationState,
    listStateId,
    filterAndSearchStateId,
    gridId,
    dispatch,
    featureName,
  ]);

  const onGridInitialize = useCallback(() => {
    setIsGridInitialized(true);
  }, []);

  return {onGridInitialize};
};
